document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('.read-more-btn') && document.querySelector('.text-container')) {

        const readMoreBtn = document.querySelector('.read-more-btn');
        const textContainer = document.querySelector('.text-container');

        readMoreBtn.addEventListener('click', function () {
            textContainer.classList.toggle('text-expanded');

            if (textContainer.classList.contains('text-expanded')) {
                readMoreBtn.textContent = myLocalizedText.readLess;
            } else {
                readMoreBtn.textContent = myLocalizedText.readMore;
            }

        });
    }

    function setupTabs() {
        // Select all elements with the 'data-tabs' attribute
        const tabContainers = document.querySelectorAll('[data-tabs]');

        tabContainers.forEach((tabContainer) => {
            // Get all <li> elements within the current tab container
            const tabs = tabContainer.querySelectorAll('li');

            tabs.forEach((tab) => {
                tab.addEventListener('click', () => {
                    // Remove the 'active' class from all <li> elements
                    tabs.forEach((t) => t.classList.remove('active'));

                    // Add the 'active' class to the clicked <li> element
                    tab.classList.add('active');

                    // Get the data-content value of the clicked <li>
                    const contentValue = tab.getAttribute('data-content');


                    // Find the .tabs-content element (next sibling of the data-tabs element)
                    const tabsContent = tab.closest('.tabs-block').querySelector('.tabs-content');

                    if (tabsContent) {
                        // Set the contentValue inside the <p>
                        tabsContent.innerHTML = contentValue;
                    }

                });
            });
        });
    }

    // Call the function to set up the tabs
    setupTabs();

    // Attach event listeners to all elements with data-sort-tag
    document.querySelectorAll('[data-sort-tag]').forEach(sortTagElement => {
        sortTagElement.addEventListener('click', () => {
            // Remove 'btn-outline-purple' from all sorting buttons
            document.querySelectorAll('[data-sort-tag]').forEach(el => el.classList.remove('btn-outline-purple'));

            // Add 'btn-outline-purple' to the clicked element
            sortTagElement.classList.add('btn-outline-purple');

            const sortBy = sortTagElement.getAttribute('for'); // Get the 'for' attribute
            const toplistElement = document.querySelector('[data-list]'); // Element with data-toplist
            const tiles = Array.from(toplistElement.querySelectorAll('.tile')); // All .tile elements

            // Determine the attribute to sort by based on the 'for' value
            let dataAttribute;
            switch (sortBy) {
                case 'rdo_rated':
                    dataAttribute = 'data-rating';
                    break;
                case 'best-by-perc':
                    dataAttribute = 'data-percentage';
                    break;
                case 'free-spins':
                    dataAttribute = 'data-spins';
                    break;
                case 'best-bonus':
                    dataAttribute = 'data-bonus';
                    break;
                default:
                    return;
            }

            // Sort tiles by the specified attribute in descending order
            tiles.sort((a, b) => {
                const aValue = parseFloat(a.getAttribute(dataAttribute)) || 0; // Default to 0 if missing
                const bValue = parseFloat(b.getAttribute(dataAttribute)) || 0; // Default to 0 if missing
                return bValue - aValue; // Descending order
            });

            // Append sorted elements back to the toplist element
            tiles.forEach(tile => toplistElement.appendChild(tile));
        });
    });

    document.querySelectorAll(".header-menu > li").forEach(item => {
        item.classList.add("hover");
    });

    const loadBlockMoreBtn = document.getElementById('load-more-search-slots');
    const slotBlockContainer = document.getElementById('slot-list');
    const searchBtn = document.getElementById('slot-search-button');

    // ✅ "Show More" Functionality
    if (loadBlockMoreBtn) {
        loadBlockMoreBtn.addEventListener("click", function () {
            console.log("clicked");
            let offset = parseInt(loadBlockMoreBtn.getAttribute("data-offset"));
            let query = document.querySelector("#slot-search-form input").value;

            let formData = new FormData();
            formData.append("action", "load_more_slots");
            formData.append("offset", offset);
            formData.append("query", query);

            console.log('transmitted = ' + query)

            fetch(myLocalizedText.ajax_url, {
                method: "POST",
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (offset === 0) {
                        slotBlockContainer.innerHTML = data.html; // Replace results for new search
                    } else {
                        slotBlockContainer.insertAdjacentHTML("beforeend", data.html); // Append for "Show More"
                    }

                    if (data.has_more) {
                        loadBlockMoreBtn.setAttribute("data-offset", offset + 12);
                        loadBlockMoreBtn.style.display = "block"; // ✅ Show button if more results exist
                    } else {
                        loadBlockMoreBtn.style.display = "none"; // ✅ Hide button instead of removing it
                    }
                })
                .catch(error => {
                    console.error("AJAX request failed:", error);
                });
        });
    }

    if (searchBtn) {
        searchBtn.addEventListener("click", function (e) {
            e.preventDefault();

            let slotBlock = document.querySelector("#slot-search-form").closest(".slot-block");
            slotBlock.querySelector(".slot-container").innerHTML = "";
            let loadBlockMoreBtn = slotBlock.querySelector("#load-more-search-slots");
            loadBlockMoreBtn.setAttribute("data-offset", "0");
            loadBlockMoreBtn.click();

        });
    }

    if (document.getElementById("slot-search")) {
        document.getElementById("slot-search").addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                event.preventDefault();
                document.getElementById("slot-search-button").click();
            }
        });
    }

});